module.exports = __webpack_public_path__ + "img/icon-linkedin.a8a4a7f5.svg";